// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"AboutThisEventModal_modalContainer___9jCJ","modulesWrapper":"AboutThisEventModal_modulesWrapper__HxtfO"};